'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagKzAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.98023e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -1.92082e-05 6.66667 2.98023e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M2.98023e-06 0H28V20H0L2.98023e-06 0Z", fill: "#30C6E0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 14C16.2091 14 18 12.2091 18 10C18 7.79086 16.2091 6 14 6C11.7909 6 10 7.79086 10 10C10 12.2091 11.7909 14 14 14Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3682 17.1495L14 14.7136L15.6318 17.1495L16.0452 14.2468L18.5723 15.7334L17.6852 12.9389L20.6071 13.1818L18.5954 11.0489L21.3333 10L18.5954 8.95112L20.6071 6.81819L17.6852 7.06111L18.5723 4.26657L16.0452 5.75318L15.6318 2.85053L14 5.28639L12.3682 2.85053L11.9548 5.75318L9.42774 4.26657L10.3148 7.06111L7.3929 6.81819L9.40457 8.95112L6.66667 10L9.40457 11.0489L7.3929 13.1818L10.3148 12.9389L9.42774 15.7334L11.9548 14.2468L12.3682 17.1495ZM18.6667 10C18.6667 12.5773 16.5773 14.6667 14 14.6667C11.4227 14.6667 9.33333 12.5773 9.33333 10C9.33333 7.42267 11.4227 5.33333 14 5.33333C16.5773 5.33333 18.6667 7.42267 18.6667 10Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.33333 1.66667C1.33333 1.48257 1.48257 1.33333 1.66667 1.33333H2.33333C2.51743 1.33333 2.66667 1.48257 2.66667 1.66667V2.33333C2.66667 2.51743 2.51743 2.66667 2.33333 2.66667H1.66667C1.48257 2.66667 1.33333 2.51743 1.33333 2.33333V1.66667Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.33333 4.33333C1.33333 4.14924 1.48257 4 1.66667 4H2.33333C2.51743 4 2.66667 4.14924 2.66667 4.33333V5C2.66667 5.18409 2.51743 5.33333 2.33333 5.33333H1.66667C1.48257 5.33333 1.33333 5.18409 1.33333 5V4.33333Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.66667 6.66667C1.48257 6.66667 1.33333 6.81591 1.33333 7V7.66667C1.33333 7.85076 1.48257 8 1.66667 8H2.33333C2.51743 8 2.66667 7.85076 2.66667 7.66667V7C2.66667 6.81591 2.51743 6.66667 2.33333 6.66667H1.66667Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.33333 9.66667C1.33333 9.48257 1.48257 9.33333 1.66667 9.33333H2.33333C2.51743 9.33333 2.66667 9.48257 2.66667 9.66667V10.3333C2.66667 10.5174 2.51743 10.6667 2.33333 10.6667H1.66667C1.48257 10.6667 1.33333 10.5174 1.33333 10.3333V9.66667Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.66667 12C1.48257 12 1.33333 12.1492 1.33333 12.3333V13C1.33333 13.1841 1.48257 13.3333 1.66667 13.3333H2.33333C2.51743 13.3333 2.66667 13.1841 2.66667 13V12.3333C2.66667 12.1492 2.51743 12 2.33333 12H1.66667Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.33333 15C1.33333 14.8159 1.48257 14.6667 1.66667 14.6667H2.33333C2.51743 14.6667 2.66667 14.8159 2.66667 15V15.6667C2.66667 15.8508 2.51743 16 2.33333 16H1.66667C1.48257 16 1.33333 15.8508 1.33333 15.6667V15Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.66667 17.3333C1.48257 17.3333 1.33333 17.4826 1.33333 17.6667V18.3333C1.33333 18.5174 1.48257 18.6667 1.66667 18.6667H2.33333C2.51743 18.6667 2.66667 18.5174 2.66667 18.3333V17.6667C2.66667 17.4826 2.51743 17.3333 2.33333 17.3333H1.66667Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.66667 16.3333C2.66667 16.1492 2.8159 16 3 16H3.66667C3.85076 16 4 16.1492 4 16.3333V17C4 17.1841 3.85076 17.3333 3.66667 17.3333H3C2.8159 17.3333 2.66667 17.1841 2.66667 17V16.3333Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3 13.3333C2.8159 13.3333 2.66667 13.4826 2.66667 13.6667V14.3333C2.66667 14.5174 2.8159 14.6667 3 14.6667H3.66667C3.85076 14.6667 4 14.5174 4 14.3333V13.6667C4 13.4826 3.85076 13.3333 3.66667 13.3333H3Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.66667 11C2.66667 10.8159 2.8159 10.6667 3 10.6667H3.66667C3.85076 10.6667 4 10.8159 4 11V11.6667C4 11.8508 3.85076 12 3.66667 12H3C2.8159 12 2.66667 11.8508 2.66667 11.6667V11Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3 8C2.8159 8 2.66667 8.14924 2.66667 8.33333V9C2.66667 9.1841 2.8159 9.33333 3 9.33333H3.66667C3.85076 9.33333 4 9.18409 4 9V8.33333C4 8.14924 3.85076 8 3.66667 8H3Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.66667 5.66667C2.66667 5.48257 2.8159 5.33333 3 5.33333H3.66667C3.85076 5.33333 4 5.48257 4 5.66667V6.33333C4 6.51743 3.85076 6.66667 3.66667 6.66667H3C2.8159 6.66667 2.66667 6.51743 2.66667 6.33333V5.66667Z",
          fill: "#FFCD4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3 2.66667C2.8159 2.66667 2.66667 2.81591 2.66667 3V3.66667C2.66667 3.85076 2.8159 4 3 4H3.66667C3.85076 4 4 3.85076 4 3.66667V3C4 2.81591 3.85076 2.66667 3.66667 2.66667H3Z",
          fill: "#FFCD4B"
        }
      )
    ]
  }
);
const VpFlagKzAsset = forwardRef(FlagKzAsset);

export { VpFlagKzAsset as default };
